export const getFirstTwoLetters = (name: string) => {
  const words = name.trim().split(/\s+/).filter(Boolean);

  return words.length >= 2 ? words[0][0] + words[1][0] : words[0].slice(0, 2);
};
